module.exports = __webpack_public_path__ + "static/media/camp.25ca0386.png";